
import { $CommonServiceFn, $postServiceFn, Services } from '../../network/Services';
import AoUrl from "../../network/url";
import { useEffect, useState, useContext, useRef, useMemo } from "react";
import konsole from "../../network/konsole";
import { isNotValidNullUndefile, lplSubtinent, time_mattersSubtinent, federal_way_plazaId, demo, formatToUS, capitalizeFirst} from "../../control/Constant";
import CommonTable from '../CommonTable';
import { useNavigate } from 'react-router-dom';
import config from '../../config.json'
import Loader from '../Loader';
// import moment from 'moment';
import moment from 'moment-timezone';
import * as XLSX from "xlsx-js-style";
import Toaster from '../Toaster';
import ReusableSelect from '../ReusableSelect';
import CustomCalander from '../CustomCalander';
import ExcelExportTable from '../ExcelExportTable';


const BillingCenterTableNew = (props) => {
  const {toDateTable,setToDateTable,fromDateTable,setFromDateTable,selectedUserId, setSelectedUserId,staffId, setStaffId} = props
  const initialState = {
    index: null,
    showDocumentOptions: false,
  };

  const [selectedRowData, setSelectedRowData] = useState({ ...initialState });
  const [selectedFileUpload, setSelectedFileUpload] = useState({ ...initialState });
  const [selectedFileCabinet, setSelectedFileCabinet] = useState({ ...initialState });
  const [showannualagreementmodal, setshowannualagreementmodal] = useState(false)
  const [showFeeAgreementModal, setshowFeeAgreementModal] = useState(false);
  const [clientdataforannualagreement, setclientdataforannualagreement] = useState([])
  const [transactionStatus, setTransactionStatus] = useState(null);
  const [orderIDFromUrl, setOrderIDFromUrl] = useState(null);
  const [clientDataForFeeAgreement, setClientDataForFeeAgreement] = useState([]);
  const [AssigneeList, setAssigneeList] = useState([])
  const [showStepmodal, setShowstepmodal] = useState({ show: false, data: null })
  const [showAiDoc, setShowAiDoc] = useState(false)
  const [aiDocuments, setAiDocuments] = useState()
  const [showSelectAvailableDocModal, setShowSelectAvailableDocModal] = useState(null)
  const [selectedDocument, setSelectedDocument] = useState([])
  const [documentNameVersion, setDocumentNameVersion] = useState({ client_name: "", version: "" });
  const [selectedMemberId, setSelectedMemberId] = useState(null)
  const [showTime, setShowTime] = useState([])
  const [paralegal_client_name, setParalegal_client_name] = useState("")
  const [showPaymentTable, setShowPaymentTable] = useState(false);
  const [paymentTableData, setPaymentTableData] = useState()
  const [openModal, setOpenModal] = useState(false)
  const [selectedUserData, setSelectedUserData] = useState()
  const loggedUserData = ''
  const [sessionsData, setSessionsData] = useState()
  const [sepratepayment, setSepratepayment] = useState(false)
  const [payremaningModal, setPayremaningModal] = useState(false)
  const [lastIndex, setLastIndex] = useState(0)
  const [selectDate, setSelectDate] = useState(1)
  const [customDate, setCustomdate] = useState({ startDate: '', endDate: '' })
  const [revenueData, setRevenuedata] = useState(0)
  const [toDate, setToDate] = useState(null);
  const [fromDate, setFromDate] = useState(null);
  const [toast, setToast] = useState(null);
  const [useLoader, setuseLoader] = useState(false)
    const [result, setResult] = useState()
  const [filter, setFilter] = useState({
    header: "name",
    value: "",
  });
    const [sortOrder, setSortOrder] = useState("asc");
    const [clientName,setClientname] = useState([])
    const [filterValue,setFilterValue] = useState('')
    

  const [today, setToday] = useState(new Date());
    const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState({
    AO: true,
    TM: true,
  });
  const [selectRevenue,setSelectrevenue] = useState('')

//   console.log("e3qwd9",props?.client)

  function formatToYMD(date) {
    return [
    date.getFullYear(),
    String(date.getMonth() + 1).padStart(2, "0"),
    String(date.getDate()).padStart(2, "0")
      ].join("-");
  }
    


    useEffect(() => {
    const dayOfWeek = today.getDay(); // Sunday = 0, Monday = 1, ..., Saturday = 6
    // Calculate From Date (Monday of this week or today if today is Monday)
    const mondayOffset = dayOfWeek === 1 ? 0 : -((dayOfWeek + 6) % 7);
    const from = new Date(today);
    from.setDate(today.getDate() + mondayOffset);
    // setFromDate(from.toISOString().split("T")[0]);
    // setFromDatef(from.toISOString().split("T")[0])
    setFromDate(formatToYMD(from));
    setFromDatef(formatToYMD(from));

    // Calculate To Date (upcoming Sunday from FromDate)
    const to = new Date(from);
    to.setDate(from.getDate() + 6);
    // setToDate(to.toISOString().split("T")[0]);
    // setToDatef(to.toISOString().split("T")[0])
    setToDate(formatToYMD(to));
    setToDatef(formatToYMD(to));

      if (isNotValidNullUndefile(props?.subtenantId)) {
        getFinancecalculationfunc(formatToYMD(from),formatToYMD(to))
      }
  }, [props?.subtenantId]);


  const headerFedral = ['Tenant Name', 'Unit number', 'Order Id', 'Product', 'Amount']

 const federalTotalAmtFun = () => {
  const data = props?.client || [];

  const total = data.reduce((acc, client) => {
    return acc + (client?.orderDetailsVMs || []).reduce((subAcc, order) => {
      const cost = order?.totalCost || 0;
      return subAcc + (order?.isRefund || order?.isReverse ? -cost : cost);
    }, 0);
  }, 0);

  const isNeg = total < 0;
  return `${isNeg ? '-' : ''}$${formatUSNumber(Math.abs(total))}`;
};

  useEffect(() => {
    if (isNotValidNullUndefile(loggedUserData)) {
      if (props?.client.length > 0) {
        const queryParams = new URLSearchParams(window.location.search);
        const trxnStatus = queryParams.get('TrxnStatus');
        const orderId = queryParams.get('OrderId');
        if (trxnStatus == "SUCCESS") {
          // handlePaymentModal(props?.client[0])
          // let url = `${intakeBaseUrl}paralegal?toogle=2&search=`
          // window.location.replace(url);
          setSessionsData(loggedUserData)
          sessionStorage.removeItem("userDeatils")
        }
      }
    }
  }, [loggedUserData])

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const transactionStatus = urlParams.get("TrxnStatus") || props?.isPaymentStatus;
    const orderIDFromUrl = urlParams.get("OrderId") || props?.isPaymentOrderId;
    const userEmail = sessionStorage.getItem('feeAgreementUser');
    konsole.log(orderIDFromUrl, transactionStatus, props?.isFeeAgreementPayment, "TransactionStatusWithOrderID", userEmail, props)
    if (orderIDFromUrl && transactionStatus === "SUCCESS" && props?.isFeeAgreementPayment == true && isNotValidNullUndefile(userEmail) && props.client?.length > 0) {
      setshowFeeAgreementModal(true)
      setTransactionStatus(transactionStatus);
      setOrderIDFromUrl(orderIDFromUrl);
    } else {
      setTransactionStatus(transactionStatus);
    }
    if (orderIDFromUrl && transactionStatus === "SUCCESS" && props?.isFeeAgreementPayment == true && props.client?.length > 0 && isNotValidNullUndefile(userEmail)) {
      openAnnualModalFileTable(props.client[0]);
    }
  }, [props?.isFeeAgreementPayment, props.client]);

  useEffect(() => {
    const amaUserEmail = sessionStorage.getItem('amaUser');
    const subtenantId = sessionStorage.getItem('SubtenantId')
    const userDetails = JSON.parse(sessionStorage.getItem('userLoggedInDetail'))

    if (props?.isAmaPayment == true && props?.client?.length > 0 && isNotValidNullUndefile(amaUserEmail)) {
      setSelectedRowData({ index: 0, showDocumentOptions: true });
      showannualagreementmodalfun(props.client[0])
    }
  }, [props?.isAmaPayment, props?.client])

  useEffect(() => {
    setSelectedRowData({ ...initialState });
  }, [props?.client]);


  useEffect(() => {
    const subtenantId = sessionStorage.getItem('SubtenantId')
    const userDetails = JSON.parse(sessionStorage.getItem('userLoggedInDetail'))
    const stateObj = JSON.parse(sessionStorage.getItem('stateObj'));
    getAssigneeFunction(subtenantId, userDetails)
  }, [props?.subtenantId])




  const getFinancecalculationfunc = (from,to) => {
     let jsonObj = {
      subtenantId: props?.subtenantId,
      startDate: from,                     // today - 7 days
      endDate: to,   // today
      fEndDate: to,   // today
      fStartDate: from,   // today
    };
    let getFinanceCalculation = Services.getFinancecalculation(jsonObj)
    getFinanceCalculation.then((res) => {
      setRevenuedata(res.data.data)
    }).catch((err) => {
    })
  }

  const openAnnualModalFileTable = (client) => {
    localStorage.setItem("clientDataForFeeAgreement", JSON.stringify(client));
    setshowFeeAgreementModal(!showFeeAgreementModal);
    setClientDataForFeeAgreement(client);
  }

    const StaffTypes = [
  { value: "1", label: "Originating" },
  { value: "2", label: "Responsible" },
];

  const handleDropDown =(val,name)=>{
  if(name == 'users'){
     setSelectedUserId(val?.length > 0 && val?.map((item) => item))
  }else{
    setStaffId(val)
    setSelectedUserId()
  }
  }

  const returnId =()=>{
    if(isNotValidNullUndefile(selectedUserId) && selectedUserId.length > 0 && selectedUserId !== false && selectedUserId != 'false'){
      return selectedUserId
    }else{
      return null
    }
  }
  const setPaymentData = (fromDates,toDates,type,fromDatesF,toDatesF,fromDateTables,toDateTables,timeMatters) => {
    // console.log("j35w4hteasf",fromDates,"--toDates--",toDates,"--toDates--",type,"--fromDatesF--",fromDatesF,"--toDatesF--",toDatesF,"--fromDateTables--",fromDateTables,"--toDateTables--",toDateTables,"--timeMatters--",timeMatters)
    setFilter();
    setFilterValue();
    // console.log("89ir2fwedsa",fromDates,"----", toDates)
    // console.log("r2fwedsa",(new Date(fromDates) ,"----", new Date(toDates)))
      if ((new Date(fromDates) > new Date(toDates)) || (new Date(fromDatesF) > new Date(toDatesF)) || (new Date(fromDateTables) > new Date(toDateTables))) {
        setToast({ message: 'From date cannot be greater than To date.', type: "error" });
        return;
      }
      else{

      }

        if((isNotValidNullUndefile(fromDates) && isNotValidNullUndefile(toDates)) || (isNotValidNullUndefile(fromDatesF) && isNotValidNullUndefile(toDatesF))){
          let jsonObj = {
            "subtenantId": props?.subtenantId,
            "startDate": fromDates,
            "endDate": toDates,
            "fStartDate": fromDatesF,
            "fEndDate": toDatesF
            // "subtenantId": props?.subtenantId,
            // "startDate": new Date(fromDates),
            // "endDate": new Date(toDates),
            // "fStartDate": new Date(fromDatesF),
            // "fEndDate": new Date(toDatesF)
          }
          setuseLoader(true)
          let getFinanceCalculation = Services.getFinancecalculation(jsonObj)
          // console.log("r3qdad",getFinanceCalculation)
          getFinanceCalculation.then((res) => {
            // console.log("908yhu",res.data.data)
            setRevenuedata(res.data.data)
            setuseLoader(false)
          }).catch((err) => {
            setuseLoader(false)

          })
        }
        if(type !== 'Table') return
        if((isNotValidNullUndefile(fromDateTables) && !isNotValidNullUndefile(toDateTables))
        || (!isNotValidNullUndefile(fromDateTables) && isNotValidNullUndefile(toDateTables))){
          setToast({ message: 'Please fill your date.', type: "error" });
        return;
        }
        //   let url = AoUrl.get_UserbyName; // Old api to get clients
          let url = AoUrl.getClientOrderList; // New Api to get clients
          
        //   let inputData = { // Old json
        //     pageNumber: 1,
        //     rowsOfPage: 40,
        //     searchingText: null,
        //     subtenantId: props?.subtenantId,
        //     isTimeMatterClient: timeMatters,
        //     isRecordDeatils: true,
        //     startDate: isNotValidNullUndefile(fromDateTables) ?  fromDateTables  : null,
        //     endDate: isNotValidNullUndefile(toDateTables) ? toDateTables :  null,
        //     originatingStaffUserIds: staffId == 1 ? returnId() : null,
        //     responsibleAttorneyUserIds: staffId == 2 ? returnId() : null

        //   };

        const dayOfWeek = today.getDay();
        const mondayOffset = dayOfWeek === 1 ? 0 : -((dayOfWeek + 6) % 7);

        const from = new Date(today);
        from.setDate(today.getDate() + mondayOffset);
        const to = new Date(from);
        to.setDate(from.getDate() + 6);

        // console.log("00043w",fromDateTable,"--toDateTable",toDateTable)
          let inputData = { // New json
            searchingText: props?.searchText|| null,
            subtenantId: props?.subtenantId,
            // startDate: isNotValidNullUndefile(fromDateTable) ? fromDateTable : null,
            // endDate: isNotValidNullUndefile(toDateTable) ? toDateTable : null,
            startDate: isNotValidNullUndefile(fromDateTable) ? fromDateTable : formatToYMD(from),
            endDate: isNotValidNullUndefile(toDateTable) ? toDateTable : formatToYMD(to),
            originatingStaffUserIds: staffId == 1 ?  returnId() : null,
            responsibleAttorneyUserIds: staffId == 2 ? returnId() : null,
            pageNumber: 1,
            rowsOfPage: 40,
          }
          
          props?.setTimematter(timeMatters)
          props?.setPageNumber(1)
          let fwppJson = {
              "subtenantId": federal_way_plazaId,
            //   "startDate": isNotValidNullUndefile(fromDateTables) ?  fromDateTables  : null,
            //   "endDate": isNotValidNullUndefile(toDateTables) ? toDateTables :  null,
            "startDate": isNotValidNullUndefile(fromDateTable) ? fromDateTable : formatToYMD(from),
            "endDate": isNotValidNullUndefile(toDateTable) ? toDateTable : formatToYMD(to),
              "pageNumber": 1,
              "rowsOfPage": 40,
              // "clientUserId": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
              // "searchField": "string"
            }

          setuseLoader(true)
          let jsonObj = subtenantIds == federal_way_plazaId ? fwppJson : inputData
          if(subtenantIds == federal_way_plazaId){
            url = AoUrl.getOrderDetailbySubtenantId;
          }
          $CommonServiceFn.InvokeCommonApi("POST", url, jsonObj, (response) => {
            if (response) {
              setuseLoader(false)
              const clientResponse = response?.data?.data || [];
              // console.log("54tger",clientResponse)
              props?.setClient(clientResponse)
              if( !isNotValidNullUndefile(fromDateTable)){
                setFromDate(formatToYMD(from));
                setFromDatef(formatToYMD(from));
                setFromDateTable(formatToYMD(from));
              }
              if( !isNotValidNullUndefile(toDateTable)){
                setToDate(formatToYMD(to));
                setToDatef(formatToYMD(to));
                setToDateTable(formatToYMD(to));
              }
              const atornyesTotalAmout = updateAttorneyAmountAndReturnNew(clientResponse)
              if(selectedUserId?.length > 0){
                const result = sumAttorneyAmounts(atornyesTotalAmout);
                setResult(result)
              }
            }
         
          })


  }
  const showannualagreementmodalfun = (client) => {
    setshowannualagreementmodal(!showannualagreementmodal)
    setclientdataforannualagreement(client)
  }

  const getAssigneeFunction = async (subtenantId, userDetails) => {
    konsole.log(subtenantId, userDetails, "subtenantIduserDetails")
    let jsonObj = {
      subtenantId: props?.subtenantId,
      // roleId: 13,
      userType : 'STAFF'
    }
    if (isNotValidNullUndefile(props?.subtenantId)) {
      const getAssigneeList = Services.getUserListByRoleIdservice(jsonObj)
      getAssigneeList.then((res) => {
        konsole.log(res, "getAssigneeList")
        if (res == 'err') return;
        setAssigneeList(res.data.data)
      })
    }
  }
  function formatUSNumber(amountStr) {
    const cleaned = String(amountStr).replace(/,/g, "");
    const n = parseFloat(cleaned);
    return isNaN(n)
      ? ""
      : n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function formatUSNumberExcel(amountStr) {
    const cleaned = String(amountStr).replace(/,/g, "");
    const n = parseFloat(cleaned);
    if (isNaN(n)) return "";
    const str = n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    return str.replace(/\.00$/, '').replace(/(\.[1-9])0$/, '$1');
  }

//   function formatUSNumberAndNegativeAMt(amountStr) {
    
//     const cleaned = String(amountStr).replace(/,/g, "");
//     const n = parseFloat(cleaned);
//     return isNaN(n)
//       ? ""
//       : n.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   }

  const returnToatlPay = (json, type) => {

    const totalPayAmount = json?.clientAuthInsVMs?.filter(r=>r.isRefund != true).reduce((sum, item) => sum + (item.payAmount || 0), 0).toFixed(2);
    // console.log(json?.clientAuthInsVMs,"jsonclientAuthInsVMs")
    let pendingAmount;

    if (isNotValidNullUndefile(json)) {
      const { totalAmount, totalDiscount } = json || {}
      const finalAmount = (totalAmount || 0) - (totalDiscount || 0) - (totalPayAmount || 0);
      pendingAmount = finalAmount.toFixed(2)

    }
    return type == "pending" ? pendingAmount > 0 ? formatUSNumber(pendingAmount) : '0': formatUSNumber(totalPayAmount) || '-'
  }

  const getNextInstallmentDate = (data) => {
    const newDate = new Date(data?.authSubsStartDate);
    let uniqueDate;
    if (data?.totalOccurrence == 9999 && data?.clientAuthInsVMs?.length) {
      const latestEntry = data?.clientAuthInsVMs.reduce((latest, current) =>
        new Date(current.payAmountDate) > new Date(latest.payAmountDate) ? current : latest);
         uniqueDate = returnStartDate99(data,latestEntry)
    } else if (data?.totalOccurrence == 1 && data?.clientAuthInsVMs?.length == 0) {
      uniqueDate = data?.installmentStartDate
    } else {
      uniqueDate = returnStartDate(data)
    }

    const nextInstallmentTime = uniqueDate;
    const nextDate = new Date(nextInstallmentTime);
    const formattedDate = `${String(nextDate.getMonth() + 1).padStart(2, '0')}/${String(nextDate.getDate()).padStart(2, '0')}/${nextDate.getFullYear()}`;
    return formattedDate;
  };

  function getDateDifferenceInDays(data) {
    const d1 = new Date(getNextInstallmentDate(data));
    const d2 = new Date();
    d1.setHours(0, 0, 0, 0);
    d2.setHours(0, 0, 0, 0);
    const diffTime = d1 - d2;
    let diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
      if(returnToatlPay(data, "pending") == 0){
        return "Payment completed"
      }else{
        if(diffDays > 0){
          if(!data?.authSubscriptionId) return '-';
         return `in ${diffDays} ${diffDays == 1 ? 'day' : 'days'}`
        }else if(diffDays == 0){
            return "on today"
        }else if(data?.installmentStartDate == null){
          return '-'
        }
        else if(diffDays <= 0){

          return `Over Due`
        }
      }


  }







    const returnStartDate = (json) => { // no use
      const { installmentStartDate,authUnit, authLength,clientAuthInsVMs } = json;
      const startDate = new Date(installmentStartDate);
      const length = parseInt(authLength);

      if (isNaN(startDate.getTime())) {
        return new Date().toISOString();
      }

      const filterData = clientAuthInsVMs.filter((ele)=> ele?.isScheduledPayment !== false)
      if (authUnit == "days") {
        // console.log('filterDataclientAuthInsVMsdays')
        const next = (clientAuthInsVMs.length == 0 || filterData.length == 0) ?  new Date(startDate.getTime()) : new Date(startDate.getTime() + length * filterData?.length * 24 * 60 * 60 * 1000);
        return isNaN(next.getTime()) ? startDate.toISOString() : next.toISOString();
        }

        if (authUnit == "months") {
                  // console.log('filterDataclientAuthInsVMsmonths')

            const updatedDate = new Date(startDate);

            if (length == 12) {
                updatedDate?.setFullYear(updatedDate.getFullYear() + 1);
            }

            else if (length < 12) {
                const originalDay = updatedDate.getDate();
                updatedDate?.setMonth(updatedDate.getMonth() + length);
                // Fix case where months don't have the original day (e.g., Feb 31 → Mar 2)
                if (updatedDate.getDate() < originalDay) {
                    updatedDate.setDate(0); // last day of previous month
                }
            }
            return (clientAuthInsVMs.length == 0 || filterData.length == 0) ?  new Date(startDate.getTime()).toISOString() :  updatedDate.toISOString();
        }

        return startDate.toISOString(); // fallback
    }
    const returnStartDate99 = (json,data) => { // no use
        const {authUnit, authLength,clientAuthInsVMs} = json;
        const { payAmountDate } = data;
        const startDate = new Date(payAmountDate);
        const length = parseInt(authLength);

        if (authUnit === "days") {
            // Add (length * index) days
            return clientAuthInsVMs.length == 0 ?  new Date(startDate.getTime()).toISOString() :  new Date(startDate.getTime() + length * 24 * 60 * 60 * 1000).toISOString();
        }

        if (authUnit === "months") {
            const updatedDate = new Date(startDate);
            if (length === 12) {
                updatedDate.setFullYear(updatedDate.getFullYear() + 1);
            }

            else if (length === 1) {
                const originalDay = updatedDate.getDate();
                updatedDate.setMonth(updatedDate.getMonth());

                // Fix case where months don't have the original day (e.g., Feb 31 → Mar 2)
                if (updatedDate.getDate() < originalDay) {
                    updatedDate.setDate(0); // last day of previous month
                }
            }
            return clientAuthInsVMs.length == 0 ?  new Date(startDate.getTime()).toISOString() :  updatedDate.toISOString();
        }

        return startDate.toISOString(); // fallback
    }
 const handlePaymentModal = async (user) => {
   let inputData = {
     pageNumber: 1,
     rowsOfPage: 40,
     subtenantId: user?.subtenantId,
   };
  const _result = await fetchUserData(inputData, user?.memberId)
    if(_result != 'err'){
    setPaymentTableData(_result)
    setSelectedUserData(_result)
    setShowPaymentTable(true)
    }
      // console.log('hagdhfjdkfhdkjfhksdj',_result)
  }

  const fetchUserData = (json, id) => {
    setuseLoader(true)
    return new Promise((resolve, reject) => {
      Services?.GetClientDetailsByUserId(json, id).then((res) => {
        if(res.data?.data?.length > 0){
          resolve(res.data?.data[0])
        }else{
          resolve('')
        }
        setuseLoader(false)
      })
        .catch((err) => {
          setuseLoader(false)
           resolve('err')
        });

    })

  };




  const headerStyle = {
    // borderBottom: "1px solid #E5E7EB",
    borderBottom: "1px solid #111318ff",
    paddingLeft: "5px",
    backgroundColor: "#FAFBFC", // optional: improves visual clarity
    fontWeight: 600,         // optional: adds emphasis
    color: "#1A1B1C",
    fontFamily: 'Roboto',
    marginLeft: '2px',
    fontSize:'15px'
  };

  const cellStyle = { padding: "7px 3px 7px 7px", borderBottom: "1px solid #111318ff", fontFamily: 'Roboto', fontWeight: 400, color: '#000000', background: 'white', fontSize:'14px',margin:'0px',height:'0px' };
    
    const getFormattedDateForCE = (value)=> {
      return moment(value).format('MM/DD/YYYY');
    }
    
    const getFormattedUTCDateForCE = (value, zone = "America/New_York") => {
    if (!value) return '';

    const dateStr = String(value);

    // Check if the time part is exactly midnight UTC
    const isMidnightUTC = dateStr.endsWith('T00:00:00') || dateStr.endsWith('T00:00:00');

    if (isMidnightUTC) {
      // Just format the UTC date without timezone conversion
      return moment.utc(value).format("MM/DD/YYYY");
    }

    // Otherwise, convert to the specified US timezone
    return moment.utc(value).tz(zone).format("MM/DD/YYYY");
    };

  const handleKeypress = (e) => {
    if (e.key == 'Enter') {
      props?.setPageNumber(1);

      if (isNotValidNullUndefile(e.target?.value) || (props?.toggled == false)) {
        props?.setLoading(!props?.loading)
      }
      else {
        // AlertToaster.warn("Empty search is not allowed when Secured Mode is enabled.")
      }
      props?.setLastPage(2);

    }
  };

  const handleSearch = (e) => {
    if (props?.apiCallStoper) return;

    props?.setSearchText(e.target.value);
    const newURL = window.location.origin + window.location.pathname + (props?.directOpen == true ? `?subtenantId=${props?.subtenantId}` : '') + `?toogle=${props?.togglebtn == true ? 1 : 2}&search=` + encodeURIComponent(e.target.value);
    if (e.target.value == "") {
      const url = window.location.origin + window.location.pathname + (props?.directOpen == true ? `?subtenantId=${props?.subtenantId}` : '');
      window.history.pushState({ path: url }, '', url);

    }
    else {
      window.history.pushState({ path: newURL }, '', newURL);
    }

  }
   function getTimePeriodLabel(days,unit) {

      if(unit == 'days'){
          if (days == 7) {
            return "Weekly";
          } else if (days == 30) {
            return "Monthly";
          } else if (days == 365) {
            return "Yearly";
          } else {
            return isNotValidNullUndefile(days) ? `${days} days` : null;
          }
          }else if(unit == 'months'){
              if(days == 1){
                return "Monthly";
              }else if(days == 12){
               return "Yearly";
              }
          }
  }
  const subtenantIds = Number(props.subtenantId)


  const handleInputChange = (field, value) => {

    // console.log("r2fewcxz",field,"--value",value)
    // const today = new Date().toISOString().split("T")[0];
    // if (!['toF','fromF'].includes(field) && (value > today)) {
    //   setToast({ message: "Future dates are not allowed", type: "error" });
    //   return; // don't update state
    // }

    if (['to'].includes(field)) {
      setToDate(value)
    } else if (field == 'toTable') {
      setToDateTable(value)
       setToDate(value)
        setToDatef(value)
    } else if (field == 'fromTable') {
      setFromDateTable(value)
      setFromDate(value)
      setFromDatef(value)
    }else if(field == 'toF'){
     setToDatef(value)
    }else if(field == 'fromF'){
      setFromDatef(value)
    }else {
      setFromDate(value)
    }

    if(['toF','fromF'].includes(field)){
         if(field == 'toF' && isNotValidNullUndefile(fromDatef) && isNotValidNullUndefile(value)){
        setPaymentData(fromDate,toDate,"",fromDatef,value,fromDateTable,toDateTable)

      }else if(field == 'fromF' && isNotValidNullUndefile(toDatef) && isNotValidNullUndefile(value)){
         setPaymentData(fromDate,toDate,"",value,toDatef,fromDateTable,toDateTable)
      }

    }else{
      if(field == 'to' && isNotValidNullUndefile(fromDate) && isNotValidNullUndefile(value)){
        setPaymentData(fromDate,value,'',fromDatef,toDatef,fromDateTable,toDateTable)
      }else if(field == 'from' && isNotValidNullUndefile(toDate) && isNotValidNullUndefile(value)){
         setPaymentData(value,toDate,'',fromDatef,toDatef,fromDateTable,toDateTable)
      }
    }



  };

function formatLocalDate(utcDateStr) {
  const date = new Date(utcDateStr);
  return date.toLocaleDateString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  });
}

const [toDatef, setToDatef] = useState(null)
const [fromDatef, setFromDatef] = useState(null)







function updateAttorneyAmountAndReturnNew(data) {
  return data.length > 0 && data?.map(client => {
    const updatedSubs = client?.clientAuthSubsVMs.length > 0 && (client?.clientAuthSubsVMs || [])?.map(sub => {
      const totalAmount = (sub.clientAuthInsVMs || []).reduce((sum, ins) => {
        return sum + (typeof ins.payAmount === 'number' ? ins.payAmount : 0);
      }, 0);

      // Return new subscription object with updated attorneyAmount
      return {
        ...sub,
        attorneyAmount: totalAmount
      };
    });

    // Return new client object with updated clientAuthSubsVMs
    return {
      ...client,
      clientAuthSubsVMs: updatedSubs
    };
  });
}
// const atornyesTotalAmout = updateAttorneyAmountAndReturnNew(props?.client)


function sumAttorneyAmounts(data) {
  const result = {};

 data.length > 0 && data?.forEach(client => {
    if (Array.isArray(client.clientAuthSubsVMs)) {
      client?.clientAuthSubsVMs.length > 0 && client?.clientAuthSubsVMs?.forEach(sub => {
        const attorneyId = staffId == 1 ? sub?.originatingAttorney : sub?.responsibleAttorney;
        const attorneyName = staffId == 1 ? sub?.originatingAttorneyName : sub?.responsibleAttorneyName;
        const amount = sub?.attorneyAmount || 0;

        if (attorneyId) {
          if (!result[attorneyId]) {
            result[attorneyId] = {
              responsibleAttorneyName: attorneyName,
              totalAmount: 0
            };
          }
          result[attorneyId].totalAmount += amount;
        }
      });
    }
  });

  return result;
}

// Reusable helper to parse accountType safely
const parseAccountType = (accountType) => {
  if (!accountType || accountType === "null" || accountType === "[]") return [];
  try {
    return JSON.parse(accountType);
  } catch {
    return [];
  }
};

let filteredData = (props?.client || []).map(client => {
  
  //  Old Code

  // const allAccountTypes = (client.clientAuthSubsVMs || []).flatMap(sub =>
  //   (sub.clientAuthInsVMs || []).flatMap(ins => parseAccountType(ins.accountType))
  // );
  // const generalAccounts = allAccountTypes.filter(acc => acc.AccountTypeId === 1);
  // const ioltaAccounts  = allAccountTypes.filter(acc => acc.AccountTypeId === 2);
  // const totalGeneral = generalAccounts.reduce((sum, acc) => sum + Number(acc.Amount || 0), 0);
  // const totalIolta   = ioltaAccounts.reduce((sum, acc) => sum + Number(acc.Amount || 0), 0);
   // const hasEmptyNonExcludedIns = client.clientAuthSubsVMs?.some(sub =>
  //   sub.clientAuthInsVMs?.some(ins =>
  //     (![7, 9, 5].includes(ins.paymentTypeId) && (!ins.accountType || ins.accountType === "null" || ins.accountType === "[]"))
  //   )
  // );
  // const hasGeneralAccountType = allAccountTypes.some(acc => acc.AccountTypeId == 1);
  // const clientGenIoltaFlag = (hasEmptyNonExcludedIns && !hasGeneralAccountType) ? 1 : ioltaAccounts.length > 0 ? 2 : 0;



  // New Code
  const allAccountTypes = parseAccountType(client?.accountType);
  const generalAccounts = allAccountTypes.filter(acc => acc.AccountTypeId === 1);
  const ioltaAccounts  = allAccountTypes.filter(acc => acc.AccountTypeId === 2);
  const totalGeneral = generalAccounts.reduce((sum, acc) => sum + Number(acc.Amount || 0), 0);
  const totalIolta   = ioltaAccounts.reduce((sum, acc) => sum + Number(acc.Amount || 0), 0);
  const hasEmptyNonExcludedIns = (![7, 9, 5].includes(client.paymentTypeId) && (!client.accountType || client.accountType === "null" || client.accountType === "[]"));
  const hasGeneralAccountType = allAccountTypes.some(acc => acc.AccountTypeId == 1);
  const clientGenIoltaFlag = (hasEmptyNonExcludedIns && !hasGeneralAccountType) ? 1 : ioltaAccounts.length > 0 ? 2 : 0;

//   console.log("12generalAccounts",generalAccounts,"ioltaAccounts",ioltaAccounts)
//   console.log("12totalGeneral",totalGeneral,"totalIolta",totalIolta)
//   console.log("23rewds",hasEmptyNonExcludedIns)
//   console.log("hasGeneralAccountType",hasGeneralAccountType)
//   console.log("clientGenIoltaFlag",clientGenIoltaFlag)


 


  // Determine main client level isgeniotaccount

  // Add isgeniotaccount to each subscription
  const updatedSubs = (client.clientAuthSubsVMs || []).map(sub => {
    const subHasEmptyNonExcludedIns = (sub.clientAuthInsVMs || []).some(ins =>
      (![7, 9, 5].includes(ins.paymentTypeId) && (!ins.accountType || ins.accountType === "null" || ins.accountType === "[]"))
    );

    const subAccountTypes = (sub.clientAuthInsVMs || []).flatMap(ins => parseAccountType(ins.accountType));
    const subHasGeneralAccountType = subAccountTypes.some(acc => acc.AccountTypeId == 1);
    // console.log(subHasEmptyNonExcludedIns,"subHasEmptyNonExcludedIns",subHasGeneralAccountType,client)
    let isgeniotaccountvalue = 0
    if(subHasEmptyNonExcludedIns || subHasGeneralAccountType){
      isgeniotaccountvalue = 1
    }
    if(subAccountTypes.some(acc => acc.AccountTypeId == 2) && !subHasGeneralAccountType ){
      isgeniotaccountvalue = 2
    }
    if(subAccountTypes?.length == 2){
      isgeniotaccountvalue = 3
    }

    return {
      ...sub,
      isgeniotaccount:isgeniotaccountvalue 
    };
  });

  return {
    ...client,
    generalAccounts,
    ioltaAccounts,
    totalGeneral,
    totalIolta,
    isgeniotaccount: clientGenIoltaFlag,
    clientAuthSubsVMs: updatedSubs
  };
}).filter(item => {
    if (!filterValue) return true;    

    if (filter === "subscriptionName") {
      return item.clientAuthSubsVMs?.some(sub =>
        sub.subscriptionName?.toLowerCase().includes(filterValue.toLowerCase())
      );
    } else if (filter === "originatingAttorneyName") {
        const filteredClientAuthSubsVMs = item.clientAuthSubsVMs?.filter(sub =>
          sub.originatingAttorneyName &&
          sub.originatingAttorneyName.toLowerCase().includes(filterValue.toLowerCase())
        );

        if (filteredClientAuthSubsVMs?.length > 0) {
          item.clientAuthSubsVMs = filteredClientAuthSubsVMs; 
        } else {
          return false;
        }

        return item;
    } else if (filter === "responsibleAttorneyName") {
        const filteredClientAuthSubsVMs = item.clientAuthSubsVMs?.filter(sub =>
          sub.responsibleAttorneyName &&
          sub.responsibleAttorneyName.toLowerCase().includes(filterValue.toLowerCase())
        );

        if (filteredClientAuthSubsVMs?.length > 0) {
          item.clientAuthSubsVMs = filteredClientAuthSubsVMs; 
        } else {
          return false;
        }

        return item;
    } else if(filter == 'NextinstallmentDue'){
      return item.clientAuthSubsVMs?.some(sub =>{
        if(filterValue.toLowerCase() == 'no installment' && returnToatlPay(sub, "pending") == 0 && sub?.totalOccurrence != 9999){
          return !getDateDifferenceInDays(sub)?.toLowerCase().includes(filterValue.toLowerCase());
        }
        return filterValue.toLowerCase() == "payment completed" ? sub?.totalOccurrence === 9999 ? getDateDifferenceInDays(sub)?.toLowerCase().includes(filterValue.toLowerCase()) : null : getDateDifferenceInDays(sub)?.toLowerCase().includes(filterValue.toLowerCase())
      }
      )
    }else if (filter === "matNo") {
        return String(item[filter] || "").toLowerCase().includes(filterValue.toLowerCase());    
    }
    else if (filter == "General/IOLTA") {
      if(filterValue == 'All') return true;
      let filterbyId =  (filterValue == 'General' ? [1,3] : filterValue == 'IOLTA' ? [2,3] : 0) 
      const filteredClientAuthSubsVMs = item.clientAuthSubsVMs?.filter(sub =>
         sub.isgeniotaccount && filterbyId.includes(sub.isgeniotaccount)
        );
        if (filteredClientAuthSubsVMs?.length > 0) {
          item.clientAuthSubsVMs = filteredClientAuthSubsVMs; 
        } else {
          return false;
        }
        return item;
    }
     else {
      return String(item[filter] || "").toLowerCase().includes(filterValue.toLowerCase());
    }
  })
  .sort((a, b) => {
    let aVal, bVal;

    if (filter === "subscriptionName") {
      aVal = a.clientAuthSubsVMs?.[0]?.subscriptionName || "";
      bVal = b.clientAuthSubsVMs?.[0]?.subscriptionName || "";
    } else if (filter === "originatingAttorneyName") {
      aVal = a.clientAuthSubsVMs?.[0]?.originatingAttorneyName || "";
      bVal = b.clientAuthSubsVMs?.[0]?.originatingAttorneyName || "";
    } else if (filter === "responsibleAttorneyName") {
      aVal = a.clientAuthSubsVMs?.[0]?.responsibleAttorneyName || "";
      bVal = b.clientAuthSubsVMs?.[0]?.responsibleAttorneyName || "";
    } else if (filter === "matNo") {
      // aVal = a.clientAuthSubsVMs?.[0]?.serviceMatNo || "";
      // bVal = b.clientAuthSubsVMs?.[0]?.serviceMatNo || "";
      aVal = a['matNo'] || '';
      bVal = b['matNo'] || '';
    }else if(filter == 'NextinstallmentDue'){
      // client?.clientAuthSubsVMs?.forEach(sub => {
      //     nArray.push(getDateDifferenceInDays(sub));
      // });
      aVal =  getDateDifferenceInDays(a.clientAuthSubsVMs?.[0]) || "";
      bVal =  getDateDifferenceInDays(b.clientAuthSubsVMs?.[0]) || "";
      // console.log(aVal,'fsjshjshjfsf')
    }
    else if(filter == 'General/IOLTA'){
      aVal =  getDateDifferenceInDays(a.clientAuthSubsVMs?.[0]) || "";
      bVal =  getDateDifferenceInDays(b.clientAuthSubsVMs?.[0]) || "";
    } 
    else {
      aVal = a[filter] || "";
      bVal = b[filter] || "";
    }

    if (typeof aVal === "string") aVal = aVal.toLowerCase();
    if (typeof bVal === "string") bVal = bVal.toLowerCase();

    if (typeof aVal === "string" && typeof bVal === "string") {
      return aVal.localeCompare(bVal);
    }

    return (aVal ?? 0) - (bVal ?? 0);
  });

  if(filterValue == 'All') {
    filteredData = (props?.client || []).map(client => {
      // Flatten all accounts from all subscriptions
      const allAccountTypes = (client.clientAuthSubsVMs || []).flatMap(sub =>
        (sub.clientAuthInsVMs || []).flatMap(ins => parseAccountType(ins.accountType))
      );

      // Separate by type
      const generalAccounts = allAccountTypes.filter(acc => acc.AccountTypeId === 1);
      const ioltaAccounts  = allAccountTypes.filter(acc => acc.AccountTypeId === 2);

      // Calculate totals
      const totalGeneral = generalAccounts.reduce((sum, acc) => sum + Number(acc.Amount || 0), 0);
      const totalIolta   = ioltaAccounts.reduce((sum, acc) => sum + Number(acc.Amount || 0), 0);

      const hasEmptyNonExcludedIns = client.clientAuthSubsVMs?.some(sub =>
        sub.clientAuthInsVMs?.some(ins =>
          (![7, 9, 5].includes(ins.paymentTypeId) && (!ins.accountType || ins.accountType === "null" || ins.accountType === "[]"))
        )
      );

      const hasGeneralAccountType = allAccountTypes.some(acc => acc.AccountTypeId == 1);

      // Determine main client level isgeniotaccount
      const clientGenIoltaFlag = (hasEmptyNonExcludedIns && !hasGeneralAccountType) ? 1 : ioltaAccounts.length > 0 ? 2 : 0;

      // Add isgeniotaccount to each subscription
      const updatedSubs = (client.clientAuthSubsVMs || []).map(sub => {
        const subHasEmptyNonExcludedIns = (sub.clientAuthInsVMs || []).some(ins =>
          (![7, 9, 5].includes(ins.paymentTypeId) && (!ins.accountType || ins.accountType === "null" || ins.accountType === "[]"))
        );

        const subAccountTypes = (sub.clientAuthInsVMs || []).flatMap(ins => parseAccountType(ins.accountType));
        const subHasGeneralAccountType = subAccountTypes.some(acc => acc.AccountTypeId == 1);
        // console.log(subHasEmptyNonExcludedIns,"subHasEmptyNonExcludedIns",subHasGeneralAccountType,client)
        let isgeniotaccountvalue = 0
        if(subHasEmptyNonExcludedIns || subHasGeneralAccountType){
          isgeniotaccountvalue = 1
        }
        if(subAccountTypes.some(acc => acc.AccountTypeId == 2) && !subHasGeneralAccountType ){
          isgeniotaccountvalue = 2
        }
        if(subAccountTypes?.length == 2){
          isgeniotaccountvalue = 3
        }

        return {
          ...sub,
          isgeniotaccount:isgeniotaccountvalue 
        };
      });

      return {
        ...client,
        generalAccounts,
        ioltaAccounts,
        totalGeneral,
        totalIolta,
        isgeniotaccount: clientGenIoltaFlag,
        clientAuthSubsVMs: updatedSubs
      };
    })
  }



// console.log(clientName,'hshsjdhsjclientName')


const filterbykey = (keyName) => {
  let nArray = ['All'];

//   console.log("99keyName",keyName)

  props?.client?.forEach(client => {
    nArray.push(client[keyName]);
    // if (keyName == "subscriptionName") {
    //     nArray.push(client[keyName]);
    // } else if(keyName == 'originatingAttorneyName'){
    // //   client?.clientAuthSubsVMs?.forEach(sub => {
    // //     if (sub?.originatingAttorneyName) {
    //     nArray.push(client?.authOriginatingAttorneyName);
    //     // }
    // //   });
    //   // nArray.push(client?.originatingAttorneyName)
    // }else if(keyName == 'responsibleAttorneyName'){
    //     nArray.push(client?.authResponsibleAttorneyName);
    // }else if(keyName == 'matNo'){
    //   // client?.clientAuthSubsVMs?.forEach(sub => {
    //   //   if (sub?.serviceMatNo) {
    //   //     nArray.push(sub.serviceMatNo);
    //   //   }
    //   // });
    //   if (client?.['serviceMatNo']) {
    //         nArray.push(client['serviceMatNo']);
    //   }
    // }else if(keyName == 'NextinstallmentDue'){
    //   client?.clientAuthSubsVMs?.forEach(sub => {
    //       nArray.push(returnToatlPay(sub, "pending") == 0 && sub?.totalOccurrence != 9999 ? 'No installment' : getDateDifferenceInDays(sub));
    //   })
    // }else if(keyName == 'General/IOLTA'){
    //   nArray.push('General')
    //   nArray.push('IOLTA')
    // } if(keyName == 'memberName'){
    //   if (client?.[keyName]) {
    //     nArray.push(client[keyName]);
    //   }
    // }
  });

  const uniqueArray = Array.from(new Set(nArray));
  return uniqueArray.map(e => ({ label: e, value: e }));
};

const handleDropDownheader = (key,value) => {
//   if(props.isUserScroll){
//   props.isUserScroll.current = false;
//   }
// console.log("1edsa",key,"---value",value)
setFilter({
    "header":key,
    "value":value
})
//   setFilter(key)
//   setFilterValue(value)
}


// console.log("?1r390qeaifilter",filter)

function calculateTotalByTypeForAll(data, type) {

  // console.log("r3qwdsa",data, type)
  if (!Array.isArray(data)) return 0;

  const accountTypeId =
    type == "General" ? 1 :
    type == "IOLTA"   ? 2 : null;

  if (!accountTypeId) return 0;

  let total = 0;

  data.forEach(item => {
    (item.clientAuthSubsVMs || []).forEach(sub => {
      (sub.clientAuthInsVMs || []) .filter(item => {
      let payAmountDate = item?.isScheduledPayment == true ? getFormattedDateForCE(item?.payAmountDate) : getFormattedUTCDateForCE(item?.payAmountDate)
      const paymentDate = new Date(payAmountDate);

      const start = new Date(fromDate);
      start.setHours(0, 0, 0, 0);   // start of day

      const end = new Date(toDate);
      end.setHours(23, 59, 59, 999); // end of day ✅

      return paymentDate >= start && paymentDate <= end;
    }).forEach(ins => {

        let parsed = [];
        try {
          if (ins.accountType) parsed = JSON.parse(ins.accountType);
        } catch {
          parsed = [];
        }

        // Case 1: explicit account type JSON
        if (Array.isArray(parsed) && parsed.length > 0) {
          parsed.forEach(acc => {
            if (acc.AccountTypeId == accountTypeId) {
              const amt = acc?.Amount;
              const cleanedAmount = typeof amt === "string" ? amt.replace(/,/g, "") : amt;
            //   console.log(acc,"accinsinsinsins")
              if(ins?.isRefund == true){
              total -= amt == 0 ? 0 : (Number(cleanedAmount) || 0);
              }else{
              total += amt == 0 ? 0 : (Number(cleanedAmount) || 0);
              }
              // console.log(total,"accAmount2",acc)
            }
          });
        }
        // Case 2: Treat null/[] accountType as "General"
        else if (accountTypeId === 1 && ![7, 9, 5].includes(ins.paymentTypeId)) {
        //   console.log(ins,"insinsinsins")
          if(ins?.isRefund == true){
          total -= Number(ins.payAmount) || 0;
          }else{
          total += Number(ins.payAmount) || 0;
          }
        }
      });
    });
  });

  return total;
}

function yearsFromNow(dateString) {
  const start = new Date(dateString);
  const now = new Date();

  let years = now.getFullYear() - start.getFullYear();

  // Adjust if the current date hasn't reached the month/day yet
  const hasNotReached =
    now.getMonth() < start.getMonth() ||
    (now.getMonth() === start.getMonth() && now.getDate() < start.getDate());

  if (hasNotReached) {
    years--;
  }

  return years > 0 ? years : 0;
}




const handleChangeTM = (type) => {
  if(props.isUserScroll){
  props.isUserScroll.current = false;
  }
  let timeValue = null;

  if (type === "TM") {
    timeValue = props?.timeMatter === true ? props.timeMatter : true;
  } else if (type === "AO") {
    timeValue = props?.timeMatter === true || props?.timeMatter == null ? false : props.timeMatter;
  }

  setPaymentData(
    fromDate,
    toDate,
    "Table",
    fromDatef,
    toDatef,
    fromDateTable,
    toDateTable,
    timeValue
  );
};


const toggleOption = async (key) => {
  const newStatus = !selected[key];

  // Updated state
  const updated = { ...selected, [key]: newStatus };
  setOpen(false)
  setSelected(updated);

  const aoChecked = updated.AO;
  const tmChecked = updated.TM;

  // -------------------------------
  // CASE 1: BOTH UNCHECKED → API("All")
  // -------------------------------
  if (!aoChecked && !tmChecked) {
    handleChangeTM("All");
    return;
  }

  // -------------------------------
  // CASE 2: BOTH CHECKED → API("All")
  // -------------------------------
  if (aoChecked && tmChecked) {
    handleChangeTM("All");
    return;
  }

  // -------------------------------
  // CASE 3: Only AO checked
  // -------------------------------
  if (aoChecked && !tmChecked) {
    handleChangeTM("AO");
    return;
  }

  // -------------------------------
  // CASE 4: Only TM checked
  // -------------------------------
  if (tmChecked && !aoChecked) {
    handleChangeTM("TM");
    return;
  }
};



  const getPlaceholder = () => {
    const ao = selected.AO;
    const tm = selected.TM;

    if (!ao && !tm) return "Please Select";
    if (ao && tm) return "All";
    if (ao) return "AO";
    if (tm) return "Time Matters";
  };

  const handleUserScroll = () => {
  if(props.isUserScroll){
    props.isUserScroll.current = true;
  }
};

function getDaysStatus(startDate) {
  const today = new Date();
  const start = new Date(startDate);

  today.setHours(0, 0, 0, 0);
  start.setHours(0, 0, 0, 0);

  const diffInMs = start.getTime() - today.getTime();
  const diffInDays = Math.ceil(diffInMs / (1000 * 60 * 60 * 24));

  if (diffInDays < 0) {
    return "Overdue";
  }

  if (diffInDays === 0) {
    return "Due Today";
  }

  return ` in ${diffInDays} days `;
}

    const base64toBlob = (data, fileType) => {
      const bytes = window.atob(data);
      let length = bytes.length;
      let out = new Uint8Array(length);
      while (length--) {
        out[length] = bytes.charCodeAt(length);
      }
      return new Blob([out], { type: fileType });
    };

    // const exportToExcel = () => {		
    //   const subtenantId = sessionStorage.getItem('SubtenantId');
    //   const jsonObj={
    //     "searchingText": props?.searchText || null,
    //     "subtenantId": subtenantId || 2,
    //     "startDate": fromDate,
    //     "endDate":toDate,
    //   }
    //   // console.log("123wq",jsonObj)
    //   let url = AoUrl.getDateViaCalenderDates;
    //   setuseLoader(true)
    //   try{
    //     $CommonServiceFn.InvokeCommonApi("POST", url, jsonObj, (response) => {
    //       const apiResponse = response?.data?.data || [];
    //         const blob = base64toBlob(apiResponse?.fileDataToByteArray, apiResponse?.fileContentType);
    //         const url = URL.createObjectURL(blob);
    //         var link = document.createElement("a");
    //         link.href = url;
    //         link.download =`Payment_Summary` ;
    //         link.click();
    //         setuseLoader(false);
    //     })
    //   }catch(err){
    //     setuseLoader(false)
    //     console.log("err",err)
    //   }
    // };

    const finalFilteredData = props?.client?.filter((clientValue) => {
        if (!filter?.value || filter?.value === "All") return true;
     
        const fieldValue = clientValue?.[filter.header];
     
        if (!fieldValue) return false;
     
        return fieldValue
          .toString()
          .trim()
          .toLowerCase() === filter?.value?.trim().toLowerCase();
      });
     
  const exportToExcelAgingOptions = () => {
    const searchText = (props?.searchText || '').toLowerCase().trim();
    const data = (props?.client || []).filter(client =>
      !searchText || (client?.memberName || '').toLowerCase().includes(searchText)
    );
    if (data.length === 0) return;

    function formatDateByZone(apiDate) {
      if (!apiDate) return '';
      const splitDate = apiDate?.split('T')?.[0];
      const [y, m, d] = splitDate?.split('-');
      return `${m}/${d}/${y}`;
    }

    const rows = data.map(client => ({
      'Client Name': client?.memberName || '',
      'Services': client?.subscriptionName || '',
      'Paid': client?.isRefund === true
        ? -(parseFloat(client?.generalAmount) || 0)
        : (parseFloat(client?.generalAmount) || 0),
      'Date': formatDateByZone(client?.usaPayAmountDate),
    }));

    const headers = Object.keys(rows[0]);
    const worksheet = XLSX.utils.json_to_sheet(rows, { origin: 'A2', skipHeader: true });

    // Force Paid column (index 2) cells to numeric type so Excel SUM works
    const paidColIndex = headers.indexOf('Paid');
    const dataRange = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = 1; R <= dataRange.e.r; R++) {
      const cellAddr = XLSX.utils.encode_cell({ r: R, c: paidColIndex });
      if (worksheet[cellAddr] && typeof worksheet[cellAddr].v === 'number') {
        worksheet[cellAddr].t = 'n';
      }
    }

    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellAddress] = {
        v: header, t: 's',
        s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'left' }, fill: { fgColor: { rgb: 'EDEDED' } } }
      };
    });

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    range.s.r = 0;
    worksheet['!ref'] = XLSX.utils.encode_range(range);
    worksheet['!cols'] = headers.map(h => ({ wch: Math.max(h.length + 5, ...rows.map(r => (r[h] || '').toString().length + 2)) }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Aging Options Payments');
    XLSX.writeFile(workbook, 'AgingOptions_Payment_Summary.xlsx');
  };

  const exportToExcelFederalWay = () => {
    const searchText = (props?.searchText || '').toLowerCase().trim();
    const data = (props?.client || []).filter(client =>
      !searchText || (client?.tenantName || '').toLowerCase().includes(searchText)
    );
    if (data.length === 0) return;

    const rows = [];
    data.forEach(client => {
      (client?.orderDetailsVMs || []).forEach(order => {
        const isRefund = order?.isRefund === true;
        const isReverse = order?.isReverse === true;
        const showMinus = isRefund;
        const rawAmt = order?.totalCost || 0;
        const amt = showMinus ? -rawAmt : rawAmt;
        rows.push({
          'Tenant Name': capitalizeFirst(client?.tenantName) || '',
          'Unit Number': order?.unitNumber || '',
          'Order Id': order?.orderId || '',
          'Product': order?.orderProductVMs?.[0]?.productName || '-',
          'Amount': amt,
        });
      });
    });

    if (rows.length === 0) return;

    const headers = Object.keys(rows[0]);
    const worksheet = XLSX.utils.json_to_sheet(rows, { origin: 'A2', skipHeader: true });

    // Force Amount column cells to numeric type so Excel SUM works
    const amtColIndex = headers.indexOf('Amount');
    const dataRangeFW = XLSX.utils.decode_range(worksheet['!ref']);
    for (let R = 1; R <= dataRangeFW.e.r; R++) {
      const cellAddr = XLSX.utils.encode_cell({ r: R, c: amtColIndex });
      if (worksheet[cellAddr] && typeof worksheet[cellAddr].v === 'number') {
        worksheet[cellAddr].t = 'n';
      }
    }

    headers.forEach((header, index) => {
      const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });
      worksheet[cellAddress] = {
        v: header, t: 's',
        s: { font: { bold: true, sz: 12 }, alignment: { horizontal: 'left' }, fill: { fgColor: { rgb: 'EDEDED' } } }
      };
    });

    const range = XLSX.utils.decode_range(worksheet['!ref']);
    range.s.r = 0;
    worksheet['!ref'] = XLSX.utils.encode_range(range);
    worksheet['!cols'] = headers.map(h => ({ wch: Math.max(h.length + 5, ...rows.map(r => (r[h] || '').toString().length + 2)) }));

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Federal Way Payments');
    XLSX.writeFile(workbook, 'FederalWay_Payment_Summary.xlsx');
  };

  const exportToExcel = () => {
      if (!finalFilteredData || finalFilteredData.length === 0) return;

      function formatDateByZone(apiDate) {
        if (!apiDate || (typeof apiDate !== "string" && typeof apiDate !== "number")) {
          return "";
        }

        const dateObj = new Date(apiDate);
        if (isNaN(dateObj.getTime())) return "";

        const month = String(dateObj.getMonth() + 1).padStart(2, "0");
        const day = String(dateObj.getDate()).padStart(2, "0");
        const year = dateObj.getFullYear();

        return `${month}-${day}-${year}`;
      }

      function accountTypearrayfun(client) {
        return client?.accountType ? JSON.parse(client.accountType) : [];
      }

      function showIolta(client) {
        const arr = accountTypearrayfun(client);
        return arr?.some((a) => a?.AccountTypeId == 2);
      }

      function getPaidAmount(client) {
        const arr = accountTypearrayfun(client);
        let paidAmount = Number(client?.payAmount || 0);
        let ioltaAmount = arr?.find((a) => a?.AccountTypeId == 2)?.Amount;

        if (ioltaAmount) {
          ioltaAmount = Number(String(ioltaAmount).replace(/,/g, ""));
          if (!isNaN(ioltaAmount)) {
            paidAmount = paidAmount - ioltaAmount;
          }
        }
        return paidAmount;
      }

      const rows = [];

      let totalPaid = 0;
      let totalGeneral = 0;
      let totalIolta = 0;

      finalFilteredData.forEach((clientValue) => {
        let row = {};

        row["Client Name"] = clientValue?.memberName || "";

        if (subtenantIds != 3 && subtenantIds !== federal_way_plazaId) {

          row["Originating Attorney"] =
            clientValue?.originatingAttorneyName ||
            clientValue?.authOriginatingAttorneyName ||
            "-";

          row["Responsible Attorney"] =
            clientValue?.authResponsibleAttorneyName ||
            clientValue?.responsibleAttorneyName ||
            "-";

          row["Matter Number"] =
            clientValue?.serviceMatNo ||
            clientValue?.matNo ||
            "-";
        }

        row["Services"] = clientValue?.subscriptionName || "";

        let paidValue =  Number(clientValue?.generalAmount || 0);
        let generalValue = Number(clientValue?.generalAmount || 0);
        let ioltaValue = Number(clientValue?.ioltaAmount || 0);

        if (clientValue?.isRefund === true) {

          if (paidValue > 0) paidValue = -paidValue;
          if (generalValue > 0) generalValue = -generalValue;
          if (ioltaValue > 0) ioltaValue = -ioltaValue;

        }

        totalPaid += paidValue;
        totalGeneral += generalValue;
        totalIolta += ioltaValue;

        row["Paid"] = Number(paidValue.toFixed(2));
        row["Date"] = formatDateByZone(clientValue?.usaPayAmountDate);

        if (subtenantIds == lplSubtinent || subtenantIds == 2) {
          row["General"] = Number(generalValue.toFixed(2));
          row["IOLTA"] = Number(ioltaValue.toFixed(2));

        }

        rows.push(row);
      });

      if (rows.length === 0) return;

      // const totalRow = {};

      // totalRow["Client Name"] = "TOTAL";

      // if (subtenantIds != 3 && subtenantIds !== federal_way_plazaId) {
      //   totalRow["Originating Attorney"] = "";
      //   totalRow["Responsible Attorney"] = "";
      //   totalRow["Matter Number"] = "";
      // }

      // totalRow["Services"] = "";
      // totalRow["Paid"] = `$${formatUSNumber(totalPaid.toFixed(2))}`;
      // totalRow["Date"] = "";

      // if (subtenantIds == lplSubtinent || subtenantIds == 2) {
      //   totalRow["General"] = `$${formatUSNumber(totalGeneral.toFixed(2))}`;
      //   totalRow["IOLTA"] = `$${formatUSNumber(totalIolta.toFixed(2))}`;
      // }

      // rows.push(totalRow);

      let headers = Object.keys(rows[0]).map((header) => {
        if (header === "Paid") return "Paid ($)";
        if (header === "General") return "General ($)";
        if (header === "IOLTA") return "IOLTA ($)";
        return header;
      });

      const totalRow = {};
      totalRow["Client Name"] = "TOTAL";

      headers.forEach((header) => {
        if (header === "Paid" || header === "General" || header === "IOLTA") {
          totalRow[header] = "";
        } else {
          totalRow[header] = "";
        }
      });

      rows.push(totalRow);

      const worksheet = XLSX.utils.json_to_sheet(rows, {
        origin: "A2",
        skipHeader: true,
      });

      headers.forEach((header, index) => {
        const cellAddress = XLSX.utils.encode_cell({ r: 0, c: index });

        worksheet[cellAddress] = {
          v: header,
          t: "s",
          s: {
            font: { bold: true, sz: 12 },
            alignment: { horizontal: "Left", vertical: "Center" },
            fill: { fgColor: { rgb: "EDEDED" } }
          }
        };
      });

      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      range.s.r = 0;
      worksheet["!ref"] = XLSX.utils.encode_range(range);

      worksheet["!cols"] = headers.map((header) => ({
        wch: Math.max(
          header.length + 5,
          ...rows.map((row) =>
            row[header] ? row[header].toString().length : 10
          )
        ),
      }));

      worksheet["!freeze"] = { xSplit: 0, ySplit: 1 };

      worksheet["!autofilter"] = {
        ref: worksheet["!ref"],
      };

      const sheetRange = XLSX.utils.decode_range(worksheet["!ref"]);

      for (let R = sheetRange.s.r; R <= sheetRange.e.r; ++R) {
        for (let C = sheetRange.s.c; C <= sheetRange.e.c; ++C) {
          const cellAddress = XLSX.utils.encode_cell({ r: R, c: C });

          if (!worksheet[cellAddress]) continue;

          worksheet[cellAddress].z = "@";
          worksheet[cellAddress].s = {
            ...worksheet[cellAddress].s,
            alignment: { horizontal: "left", vertical: "center" }
          };
        }
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Billing Data");

      XLSX.writeFile(workbook, "Payment_Summary.xlsx");
    };

    function totalPaidAmtFun(){
            const apiResp=props?.client.filter((clientValue)=>{
                if (!filter?.value || filter?.value=="All") return true;

                const fieldValue = clientValue?.[filter.header];
                // console.log("1ewqdsa",fieldValue)
              
                if (!fieldValue) return false;
              
                 return fieldValue
                    .toString()
                    .trim()
                    .toLowerCase() === filter?.value?.trim().toLowerCase();
              

              })
            if(apiResp?.length>0){
                let reduceGenAmt=apiResp.reduce((acc,curr)=>{
                    if(curr?.isRefund == true){
                        return acc-curr?.generalAmount
                    }else{
                        return acc+curr?.generalAmount
                    }
                    // <p>{(isNotValidNullUndefile((clientValue?.generalAmount))) ? <p>{clientValue?.isRefund == true ? '-' : ''}${formatUSNumber(clientValue?.generalAmount)}</p> : '$0'}</p>
                },0)
                

                let isNegative = reduceGenAmt < 0;
                if(isNegative==true){
                  reduceGenAmt=Math.abs(reduceGenAmt)
                  reduceGenAmt=formatUSNumber(reduceGenAmt);
                  return `-$${reduceGenAmt}` 
                }else{
                  reduceGenAmt=formatUSNumber(reduceGenAmt);
                  return `$${reduceGenAmt}` 
                }
            }
            return `$0`
        
    }

    function totalGeneralAmtFun(){
          const apiResp=props?.client.filter((clientValue)=>{
                if (!filter?.value || filter?.value=="All") return true;

                const fieldValue = clientValue?.[filter.header];
                // console.log("1ewqdsa",fieldValue)
              
                if (!fieldValue) return false;
              
                 return fieldValue
                    .toString()
                    .trim()
                    .toLowerCase() === filter?.value?.trim().toLowerCase();

              })
        if(apiResp?.length>0){
            let reduceGenAmt=apiResp?.reduce((acc,curr)=>{
                if(curr?.isRefund == true){
                    return acc-curr?.generalAmount
                }else{
                    return acc+curr?.generalAmount
                }
            },0)

            let isNegative = reduceGenAmt < 0;
            if(isNegative==true){
              reduceGenAmt=Math.abs(reduceGenAmt)
              reduceGenAmt=formatUSNumber(reduceGenAmt);
              return `-$${reduceGenAmt}` 
            }else{
              reduceGenAmt=formatUSNumber(reduceGenAmt);
              return `$${reduceGenAmt}` 
            }
        }
        return `$0`
    }

    function totalIoltaAmtFun(){
              const apiResp=props?.client.filter((clientValue)=>{
                if (!filter?.value || filter?.value=="All") return true;

                const fieldValue = clientValue?.[filter.header];
                // console.log("1ewqdsa",fieldValue)
              
                if (!fieldValue) return false;
              
                 return fieldValue
                    .toString()
                    .trim()
                    .toLowerCase() === filter?.value?.trim().toLowerCase();
              

              })
            if(apiResp?.length>0){
                let reduceIoltaAmt=apiResp.reduce((acc,curr)=>{
                    if(curr?.isRefund == true){
                        return acc-curr?.ioltaAmount
                    }else{
                        return acc+curr?.ioltaAmount
                    }
                },0)

                let isNegative = reduceIoltaAmt < 0;
                if(isNegative==true){
                  reduceIoltaAmt=Math.abs(reduceIoltaAmt)
                  reduceIoltaAmt=formatUSNumber(reduceIoltaAmt);
                  return `-$${reduceIoltaAmt}` 
                }else{
                  reduceIoltaAmt=formatUSNumber(reduceIoltaAmt);
                  return `$${reduceIoltaAmt}` 
                }
            }
            return `$0`
        }

        function totalRevenueFun(){
            if(props?.client.length==0){
                return `$0` 
            }
            const apiResp=props?.client.filter((clientValue)=>{
                if (!filter?.value || filter?.value=="All") return true;

                const fieldValue = clientValue?.[filter.header];
                // console.log("1ewqdsa",fieldValue)
              
                if (!fieldValue) return false;
              
                 return fieldValue
                    .toString()
                    .trim()
                    .toLowerCase() === filter?.value?.trim().toLowerCase();

              })
            if(apiResp?.length>0){
              // console.log("45rfd",apiResp,"--",props?.subtenantId == federal_way_plazaId)
              if(props?.subtenantId == federal_way_plazaId){
                 let reduceTotalFedAmt=apiResp?.reduce((acc,curr)=>{
                    return acc + (curr?.orderDetailsVMs || []).reduce((innerAcc, order) => {
                      if(order?.isRefund === true) return innerAcc - (order?.totalCost || 0);
                      if(order?.isReverse === true) return innerAcc;
                      return innerAcc + (order?.totalCost || 0);
                    }, 0);
                },0)
                 let isNegative = reduceTotalFedAmt < 0;
                  if(isNegative==true){
                    reduceTotalFedAmt=Math.abs(reduceTotalFedAmt)
                    reduceTotalFedAmt=formatUSNumber(reduceTotalFedAmt);
                    return `-$${reduceTotalFedAmt}` 
                  }else{
                    reduceTotalFedAmt=formatUSNumber(reduceTotalFedAmt);
                    return `$${reduceTotalFedAmt}` 
                }
                return `$0` 
              }
                let reduceGenAmt=apiResp?.reduce((acc,curr)=>{
                    if(curr?.isRefund == true){
                        return acc-curr?.generalAmount
                    }else{
                        return acc+curr?.generalAmount
                    }
                },0)

                let reduceIoltaAmt=apiResp.reduce((acc,curr)=>{
                    if(curr?.isRefund == true){
                        return acc-curr?.ioltaAmount
                    }else{
                        return acc+curr?.ioltaAmount
                    }
                },0)
                let totalAmt=(reduceGenAmt || 0) +(reduceIoltaAmt || 0) ;
                let isNegative = totalAmt < 0;
                if(isNegative==true){
                  totalAmt=Math.abs(totalAmt)
                  totalAmt=formatUSNumber(totalAmt);
                  return `-$${totalAmt}` 
                }else{
                  totalAmt=formatUSNumber(totalAmt);
                  return `$${totalAmt}` 
                }
            }
        }
    
        // console.log("8iubjk", props?.client)

  return (

    <>
        {toast && ( <Toaster message={toast?.message} type={toast?.type} onClose={() => setToast(null)}/>)}
        {useLoader &&  <Loader useLoader={useLoader} />}


      {showPaymentTable !== true ? <>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-1 mb-2 mt-1 mx-3"
          style={{ fontFamily: 'Roboto' }} >

          <div className="mt-0">
            <div className="p-2 rounded-[9px] shadow-md" style={{
              backgroundColor: "#FFF9EF",
              border: '1.5px solid #FFECCD',
              height: '6.5rem',
              minWidth:'14rem', width:'17rem' }}>
              <div className='flex items-center justify-center'>
                <h4 className="flex items-center justify-center gap-3 mb-0 pb-0 font-bold text-xs text-gray-800">
                  <div className="flex items-center justify-center rounded-full text-[14px]" style={{ background: '#FF8B001A' }}>
                    <img src="/revenewIcon.svg" className="p-2 m-0" /></div>{"Total Received Payment"}</h4>
              {/* <div className="text-[10px]">
              <select className="border border-[1.2px] rounded-[5px] p-1 bg-[#FFF9EF]" onChange={(e)=>{setSelectrevenue(e.target.value)}}>
                <option value="All">All</option>
                <option value="AO">AO</option>
                <option value="TM">Time Matters</option
              </select>
              </div>  */}
              </div>
              {/* {console.log(revenueData,"revenueData",selectRevenue)} */}
              {/* selectRevenue == 'AO' ? revenueData?.totalAORevenue : selectRevenue == 'TM' ? revenueData?.totalRevenueByTimeMatters :  */}
              {/* <p className="font-bold text-lg mt-1 text-center">${formatUSNumber(revenueData?.totalRevenue) || 0}</p> */}
              <p className="font-bold text-lg mt-1 text-center">{totalRevenueFun()}</p>

            </div>
          </div>
          {/* {subtenantIds != 3 && subtenantIds !== federal_way_plazaId &&  <>
            <div className="mt-0">
              <div className="p-2 rounded-[9px] shadow-md" style={{
                backgroundColor: "#FFF9EF", border: '1.5px solid #FFECCD',
                height: '6.5rem', minWidth: '14rem', width: '17rem'
              }}>
                <div className='flex items-center justify-center'>
                  <h4 className="flex items-center justify-center gap-3 mb-0 pb-0 font-bold text-xs text-gray-800">
                    <div className="flex items-center justify-center rounded-full text-[14px]" style={{ background: '#FF8B001A' }}>
                      <img src="/revenewIcon.svg" className="p-2 m-0" /></div>{"Outstanding Payment"}</h4>
                </div>

                <p className="font-bold text-lg mt-0 text-center">${formatUSNumber(revenueData?.totalUpcomingpayment) || 0}</p>
              </div>
            </div>
            <div className="mt-0">
              <div className="p-2 rounded-[9px] shadow-md" style={{
                backgroundColor: "#FFF9EF",
                border: '1.5px solid #FFECCD',
                height: '6.5rem',
                minWidth: '14rem', width: '17rem'
              }}>
                <div className='flex items-center justify-center'>
                  <h4 className="flex items-center justify-center gap-3 mb-0 pb-0 font-bold text-xs text-gray-800">
                    <div className="flex items-center justify-center rounded-full text-[14px]" style={{ background: '#FF8B001A' }}>
                      <img src="/revenewIcon.svg" className="p-2 m-0" /></div>{"Upcoming Scheduled Payment"}</h4>
                </div>

                <p className="font-bold text-lg mt-0 text-center">${formatUSNumber(revenueData?.upcomingScheduledPayment) || 0}</p>
              </div>
            </div>
          </>
          } */}
        </div>
      </> :
        <>

        </>}

      {showPaymentTable !== true ?
        <>
         <div className="flex justify-between items-center my-2 mx-3">
         {subtenantIds != 3  && subtenantIds !== federal_way_plazaId &&  <>
          <div className="flex gap-4" >
            <p className="text-[18px] font-bold mt-1">Records</p>
          {/* {(props?.subtenantId == 2 || props?.subtenantId == 742) && <div className="flex items-center mb-0">
          <button
            onClick={() => {setPaymentData(fromDate,toDate,'Table',fromDatef,toDatef,fromDateTable,toDateTable,(!props?.timeMatter))}}
            className={`relative w-32 h-7 flex items-center rounded-full px-2 transition-colors duration-300 ${
              props?.timeMatter ? 'bg-[#720d21]' : 'bg-gray-300'
            }`}
          >
            <div
              className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-md transform transition-transform duration-300 ${
                props?.timeMatter ? 'translate-x-[92px]' : 'translate-x-0'
              }`}
            ></div>
            <span
              className={`w-full text-center font-medium text-white text-xs select-none ${
                props?.timeMatter ? 'pr-7' : 'pl-7 text-[#374751]'
              }`}
            >
              {props?.timeMatter ? 'Time matters' : 'AO'}
            </span>
          </button>
        </div>} */}
        <div className="text-[14px]">
          {/* <label>Select one</label> */}
          {/* <select className="border border-[1.2px] border-[#d1d5db] rounded-[5px] p-[5px] mt-1 mb-0" onChange={(e)=>{handleChangeTM(e.target.value)}}>
            <option value="All">All</option>
            <option value="AO">AO</option>
            <option value="TM">Time Matters</option>
          </select> */}
          {/* <div className="relative inline-block w-40 mt-2"> */}
      {/* Dropdown button */}
      {/* <div
        className="border border-[1.2px] rounded-[5px] p-2 cursor-pointer bg-white"
        onClick={() => setOpen(!open)}
      >
        {getPlaceholder()}
      </div> */}

      {/* Dropdown content */}
      {/* {open && (
        <div className="absolute z-10 mt-1 w-full bg-white border rounded shadow">
          {["AO", "TM"].map((item) => (
            <label
              key={item}
              className="flex items-center p-2 gap-2 cursor-pointer hover:bg-gray-100"
            >
              <input
                type="checkbox"
                checked={selected[item]}
                onChange={() => toggleOption(item)}
              />
              <span>{item === "TM" ? "Time Matters" : item}</span>
            </label>
          ))}
        </div>
      )} */}
          {/* </div> */}
        </div>            
        </div>
            <div className="text-center gap-1 flex w-full justify-start ms-3">
              {/* <div>
              <ReusableSelect options={StaffTypes} value={staffId} findValue='value'
              onChange={(val) => handleDropDown(val, 'staff')}
               placeholder="Filtered By" showValue='label'isMulti={false} className='100%'openUp={false}/>
              </div>

                <div className=''style={{minWidth:'50%'}}>
                  <ReusableSelect options={isNotValidNullUndefile(AssigneeList) && staffId == '2' ? AssigneeList?.filter(ele=> (ele?.roleId == 13) || (ele?.roleIds?.find((ele1)=>ele1 == 13))) : AssigneeList} value={selectedUserId} findValue='userId'
                    onChange={(val) => handleDropDown(val, 'users')} isDisable={!isNotValidNullUndefile(staffId)}
                    placeholder={staffId == '1' ? "Select Staff" : "Select Attorney"} showValue='fullName' isMulti={true} className='100%' openUp={false} />
                </div> */}
            </div>
         </>
            }




           {<div className="text-center gap-1 flex w-full justify-end">
              <div className='flex'>
                <label className='me-2 mt-auto mb-auto' style={{ fontSize: "13px" }}>From</label>
                {/* <input
                  type="date" style={{ width: "40%", fontSize: "13px" }}
                  className={`px-3 py-1 border border-gray-300 rounded-md`}
                  value={isNotValidNullUndefile(fromDateTable) ? fromDateTable : ''}
                  onChange={(e) => handleInputChange('fromTable', e.target.value)}
                  max={new Date().toISOString().split('T')[0]}
                  lang="en-US"
                /> */}
            <CustomCalander isError='' placeholder="mm/dd/yyyy" name='insStartDate' id='insStartDate' allowFutureDate={true} value={isNotValidNullUndefile(fromDateTable) ? fromDateTable : ''} onChange={(val) => handleInputChange('fromTable', val)} exWidth='8rem' />

                <label className='me-2 ms-2 mt-auto mb-auto' style={{ fontSize: "13px" }}>To</label>
                {/* <input
                  type="date" style={{ width: "40%", fontSize: "13px" }}
                  className={`px-3 py-1 border border-gray-300 rounded-md`}
                  value={isNotValidNullUndefile(toDateTable) ? toDateTable : ''}
                  onChange={(e) => handleInputChange('toTable', e.target.value)}
                  max={new Date().toISOString().split('T')[0]}
                  lang="en-US"
                /> */}
            <CustomCalander isError='' placeholder="mm/dd/yyyy" name='insStartDate' id='insStartDate' allowFutureDate={true} value={isNotValidNullUndefile(toDateTable) ? toDateTable : ''} onChange={(val) => handleInputChange('toTable', val)}exWidth='8rem' />

              </div>
              <button className="btn-secondary ml-2 px-2 py-1 bg-[#720d21] text-white rounded hover:bg-[#720d21]/80"
                onClick={() => setPaymentData(fromDate,toDate,'Table',fromDatef,toDatef,fromDateTable,toDateTable,props?.timeMatter)} style={{ fontSize: "13px" }}> Apply
              </button>
              <button className="btn-secondary ml-2 me-3 px-2 py-1 bg-White text-[#720d21] border border-[#720d21] rounded"
                onClick={() =>{setFromDateTable(null);setToDateTable(null);setStaffId(null);setSelectedUserId(null);setResult();setFilter();setFilterValue();setFromDate();setToDate();}} style={{ fontSize: "13px" }}> Clear
              </button>
            </div>}



            <div className={`flex gap-2 w-${(subtenantIds == 3 || subtenantIds == federal_way_plazaId)   ? '1/3' : '3/4'} justify-start`}>
              <div className="flex items-center gap-1 w-full bg-white border border-gray-300 rounded px-2 py-1">
                <img src="/FileCabinetSearchIcon.svg" alt="search" className="w-[15px] h-[15px] m-0 p-0" />
                <input type="text" className="w-full border-none focus:outline-none text-sm p-1" placeholder="Search by client name/email..." value={props?.searchText} onChange={(e) => handleSearch(e)} onKeyDown={(e) => handleKeypress(e)}
                />
              </div>

            </div>
            {subtenantIds == lplSubtinent && subtenantIds !== federal_way_plazaId && 
              <button className="export w-1/2 bg-green-600 text-white font-semibold py-2 px-4 rounded ms-2"  onClick={exportToExcel}>Export Excel</button>
            }
            {subtenantIds == federal_way_plazaId &&
              <button className="export w-1/2 bg-green-600 text-white font-semibold py-2 px-4 rounded ms-2" onClick={exportToExcelFederalWay}>Export Excel</button>
            }
            {subtenantIds == 3 &&
              <button className="export w-1/2 bg-green-600 text-white font-semibold py-2 px-4 rounded ms-2" onClick={exportToExcelAgingOptions}>Export Excel</button>
            }
          </div>

          <div
        //    onScroll={props?.onScrollBack} 
          
          onWheel={handleUserScroll} id="" className="table-wrapper-scroll-y my-custom-scrollbars mx-3 billing-border" style={{ paddingBottom: "20px", border: '1px solid #111318ff', borderBottom: "none" }}>

            <table className="table w-full" style={{ marginBottom: 0, maxHeight: '60vh' }}>
              <thead className="sticky-header" style={{ position: "sticky", top: "0", background: "white", zIndex: "1" }}>
                {props?.subtenantId == federal_way_plazaId ?
                <tr className="py-[7px]">{headerFedral?.map((e, index) =>
                  <th key={index} style={headerStyle}>
                  <div className="flex justify-between mx-0 px-0 py-2">
                    {e === 'Amount' ? <p className="text-left m-0">{e}<br />{federalTotalAmtFun()}</p> : e}
                  </div></th>)}</tr> :
                   <tr>
                  {["Client Name","Originating / Responsible Attorney","Matter Number", "Services","Paid","Date","General","IOLTA"].filter((e) => { return subtenantIds == 3 ? !['Originating / Responsible Attorney', 'Matter Number', 'Discount','Action',"General/IOLTA",'Lapsed Payment',"General","IOLTA"].includes(e) : e }).map((text, index) => (
                    <th key={index} style={headerStyle} className="py-[7px] !text-[14px] text-left">
                      {(subtenantIds == lplSubtinent ? text == 'General/IOLTA' ? <div className="" style={{display:'flex'}}><ReusableSelect options={filterbykey('General/IOLTA')} findValue='value' onChange={(val) => handleDropDownheader('General/IOLTA',val)}
                        placeholder={'General/IOLTA'} showValue='label' isMulti={false} className='100%' openUp={false} showSearch={true}/></div> : text == 'Originating / Responsible Attorney' ? <div className="" style={{display:'flex'}}><ReusableSelect options={filterbykey('authOriginatingAttorneyName')} findValue='value' onChange={(val) => handleDropDownheader('authOriginatingAttorneyName',val)}
                        placeholder={'Originating'} showValue='label' isMulti={false} className='100%' openUp={false} showSearch={true}/><p className="mt-1">/</p><ReusableSelect options={filterbykey('authResponsibleAttorneyName')} findValue='value' onChange={(val) => handleDropDownheader('authResponsibleAttorneyName',val)}
                        placeholder={'Responsible Attorney'} showValue='label' isMulti={false} className='100%' openUp={false} showSearch={true}/></div> :(text == 'Client Name' || text == 'Services' || text == 'Matter Number' || text == 'Next installment Due')  ? <ReusableSelect options={filterbykey(text == 'Client Name' ? 'memberName': text == 'Services' ? 'subscriptionName' : text == 'Matter Number' ? 'serviceMatNo' : text == 'Next installment Due' ? 'NextinstallmentDue' : 'subscriptionName')} findValue='value' onChange={(val) => handleDropDownheader(text == 'Client Name' ? 'memberName' : text == 'Services' ? 'subscriptionName' : text == 'Matter Number' ? 'serviceMatNo' : text == 'Next installment Due' ? 'NextinstallmentDue':'subscriptionName',val)}
                        placeholder={text} showValue='label' isMulti={false} className='100%' openUp={false} showSearch={true}/> :(text != 'Date') ? <>
                        
                        <p className="text-left">{text}
                        <br />
                        {(text=="Paid")?totalPaidAmtFun():(text=="General")?totalGeneralAmtFun():totalIoltaAmtFun()}</p>

                      </>: <p className="text-left">{text}</p>  : ((text=="Paid")?<> <p className="text-left">{text}<br />{totalPaidAmtFun()}</p></>:text))}
                    </th>
                  ))}
                </tr>}
              </thead>
              <tbody>
                {/* {console.log(filteredData,"filteredData52")} */}

                {/* {subtenantIds == lplSubtinent ? (filter == 'General/IOLTA' && filterValue != 'All' ?<tr style={cellStyle}>
                            <td colSpan={10} style={{ padding: "8px" }}>
                                  <strong>Account:</strong> {filterValue || ''} &nbsp;&nbsp;
                                  <strong>Total amount:</strong> $
                                  {formatUSNumber(calculateTotalByTypeForAll(filteredData,filterValue))}
                            </td>
                          </tr>
                          : 
                          <tr style={cellStyle} className="stcikyTr">
                            <td colSpan={12} style={{ padding: "8px" }}>
                                  <strong>Total amount received in General Account: </strong>${formatUSNumber(revenueData?.totalGenRevenue) || 0} &nbsp;&nbsp;
                                  <strong>Total amount received in IOLTA Account: </strong> ${formatUSNumber(revenueData?.totalIOLTARevenue) || 0}
                            </td>
                          </tr>
                          ):''}  */}
                
                {props?.subtenantId == federal_way_plazaId ?
                  props?.client?.map((client, clientIndex) => {
                    // collect all orderIds that have been refunded
                    return (client?.orderDetailsVMs || []).map((orderDetailsVms, orderIndex) => {
                      const isRefund = orderDetailsVms?.isRefund === true;
                      const isReverse = orderDetailsVms?.isReverse === true;
                      const showMinus = isRefund;
                      const amountDisplay = showMinus
                        ? `-$${formatUSNumber(orderDetailsVms?.totalCost)}`
                        : `$${formatUSNumber(orderDetailsVms?.totalCost)}`;
                      return (
                        <tr key={`${clientIndex}-${orderIndex}`}>
                          <td style={cellStyle}>{capitalizeFirst(client?.tenantName)}</td>
                          <td style={cellStyle}>{orderDetailsVms?.unitNumber}</td>
                          <td style={cellStyle}>{orderDetailsVms?.orderId}</td>
                          <td style={cellStyle}>{orderDetailsVms?.orderProductVMs?.[0]?.productName || '-'}</td>
                          <td style={cellStyle}>
                            {amountDisplay}
                            {isRefund && <span style={{color:'black'}}> (Refunded)</span>}
                            {isReverse && <span style={{color:'black'}}> (Reversed)</span>}
                          </td>
                        </tr>
                      );
                    })
                  }) :

                 props?.client?.length > 0 && props?.client?.filter((clientValue)=>{
                    if (!filter?.value || filter?.value=="All") return true;

                    const fieldValue = clientValue?.[filter.header];
                    // console.log("1ewqdsa",fieldValue)
                  
                    if (!fieldValue) return false;
                  
                    return fieldValue
                    .toString()
                    .trim()
                    .toLowerCase() === filter?.value?.trim().toLowerCase();

                  }).map((clientValue, index) => {
                    // console.log("3qwdsax",client)
                    function formatDateByZone(apiDate) {
                        var splitStringDateMap=(apiDate)?.split("T")?.[0];
                        const [y, m,d] = splitStringDateMap?.split("-");
                        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
                        if (tz == "Asia/Kolkata" || (tz == "Asia/Calcutta")) {
                          // India → dd/mm/yyyy
                          return `${d}/${m}/${y}`;
                        }
                      
                        // US (and default) → mm/dd/yyyy
                        return `${m}/${d}/${y}`;
                      }

                      function accountTypearrayfun(clientPara1){
                        let accountTypearray = clientPara1?.accountType != undefined ? JSON?.parse(clientPara1?.accountType) : []
                        return accountTypearray
                      }

                      function generalAmtFun(clientPara1){
                        let accountTypearray = clientPara1?.accountType != undefined ? JSON?.parse(clientPara1?.accountType) : []
                        let generalAmount = (![7,9,5].includes(clientPara1?.paymentTypeId) && accountTypearray?.length == 0) ? formatUSNumber(clientPara1?.payAmount) : formatUSNumber(accountTypearray?.find((a)=> a?.AccountTypeId == 1)?.Amount);
                        return generalAmount
                      }

                      function showIolta(clientPara1){
                        let accountTypearray = clientPara1?.accountType != undefined ? JSON?.parse(clientPara1?.accountType) : []
                        let showiolta = accountTypearray?.some((a)=> a?.AccountTypeId == 2)
                        return showiolta
                      }

                      function ioltaAmountFun(clientPara1){
                        let accountTypearray = clientPara1?.accountType != undefined ? JSON?.parse(clientPara1?.accountType) : []
                        let generalAmount = (![7,9,5].includes(clientPara1?.paymentTypeId) && accountTypearray?.length == 0) ? formatUSNumber(clientPara1?.payAmount) : formatUSNumber(accountTypearray?.find((a)=> a?.AccountTypeId == 1)?.Amount);
                        let ioltaAmount = accountTypearray?.find((a)=> a?.AccountTypeId == 2)?.Amount;
                        return ioltaAmount
                      }

                      function getPaidAmount(clientPara1){

                          let accountTypearray = clientPara1?.accountType != undefined ? JSON?.parse(clientPara1?.accountType) : []
                          let ioltaAmount = (accountTypearray?.find((a)=> a?.AccountTypeId == 2)?.Amount);
                          let paidAmount=clientPara1?.payAmount
                          let showiolta = accountTypearray?.some((a)=> a?.AccountTypeId == 2)
                          let paidResultAmt=paidAmount
                          if(showiolta){
                            ioltaAmount=Number(String(ioltaAmount).replace(/,/g, ""))
                            if(isNaN(ioltaAmount)){
                              ioltaAmount=0
                            }
                            paidResultAmt=(paidAmount-ioltaAmount)
                          }
                        return paidResultAmt
                      }

                      
                         

                    return(
                        <>
                          <tr key={clientValue.id} style={cellStyle} className="reportTable">
                             {/* <td rowSpan={listLength} style={cellStyle}>{clientValue?.memberName}  - <span>{client?.signUpPlatform == 16 ? '(TM)':client?.signUpPlatform == 18 ? '(Stripe)':client?.signUpPlatform == 19 ? '(Square)' : "(AO)"}</span><br/></td> */}
                             <td style={cellStyle}><span>{clientValue?.memberName}</span></td>
                             {subtenantIds != 3  && subtenantIds !== federal_way_plazaId && 
                                <td style={cellStyle}><span> {clientValue?.originatingAttorneyName || clientValue?.authOriginatingAttorneyName || '-'} / {clientValue?.authResponsibleAttorneyName || clientValue?.responsibleAttorneyName || '-'} </span></td>}
                             {subtenantIds != 3 && subtenantIds !== federal_way_plazaId && 
                                <td style={cellStyle}><span> {clientValue?.serviceMatNo || clientValue?.matNo || '-'}</span></td>}
                            <td style={cellStyle}><span>{clientValue?.subscriptionName}</span></td>
                            <td style={cellStyle}>
                                <div className='w-[100] d-flex align-items-center'>
                                {clientValue?.isRefund == true ? <p>
                                {/* {`${(formatUSNumber(((clientValue?.payAmount)))==0 || formatUSNumber(((clientValue?.payAmount)))==0.0 || formatUSNumber(((clientValue?.payAmount)))==0.00 || formatUSNumber(((clientValue?.payAmount)))=="0")?"":"-"}$${formatUSNumber(((clientValue?.payAmount))?.toFixed(2))}`}&nbsp;{`(Refunded)`} */}
                                { (isNotValidNullUndefile((clientValue?.generalAmount))) ?<> <p>{clientValue?.isRefund == true ? '-' : ''}${formatUSNumber(clientValue?.generalAmount)}{(clientValue?.isRefund == true)?" (Refunded)":""}</p> </> : '$0'}
                                </p> :
                                clientValue?.isReverse == true ? <p>
                                { (isNotValidNullUndefile((clientValue?.generalAmount))) ?<> <p>${formatUSNumber(clientValue?.generalAmount)}{(clientValue?.isReverse == true)?" (Reversed)":""}</p> </> : '$0'}
                                </p> :
                                <p>
                                {`$${formatUSNumber((getPaidAmount(clientValue))?.toFixed(2))}`}&nbsp;{`(${clientValue?.paymentTypeId == 5 ? 'TM' : clientValue?.paymentTypeId == 7 ? 'Stripe' : clientValue?.paymentTypeId == 9 ? 'Square' : 'AO'})`}
                                </p>
                                }
                               </div>
                            </td>
                            <td style={cellStyle} className="mt-0 top-0">
                                <div  className='w-[100] d-flex align-items-center'>
                                    <p>{formatDateByZone(clientValue?.usaPayAmountDate)} </p>
                                </div>
                            </td>
                            {(subtenantIds == lplSubtinent || subtenantIds == 2) && 
                            <td style={cellStyle}>
                            <div>
                                <p>{(isNotValidNullUndefile((clientValue?.generalAmount))) ? <p>{clientValue?.isRefund == true ? '-' : ''}${formatUSNumber(clientValue?.generalAmount)}{(clientValue?.isRefund == true)?" (Refunded)":(clientValue?.isReverse == true)?" (Reversed)":""}</p> : '$0'}</p>
                            </div>
                            </td>
                            }
                            {(subtenantIds == lplSubtinent || subtenantIds == 2) && <td style={cellStyle}>
                            <div>
                                <p>
                                  {showIolta(clientValue) ? <p>  {clientValue?.isRefund == true ? '-' : ''}${formatUSNumber((clientValue?.ioltaAmount))}{(clientValue?.isRefund == true)?" (Refunded)":(clientValue?.isReverse == true)?" (Reversed)":""} </p> : "$0" }
                                </p>
                            </div>
                            </td>}
                            {/* <td style={cellStyle}>
                                N/A O
                            </td>
                            <td style={cellStyle}>
                                N/A NI
                            </td>
                            <td style={cellStyle}>
                                N/A L
                            </td> */}
                                {/* {((lplSubtinent == subtenantIds) || (time_mattersSubtinent == subtenantIds) || subtenantIds == 2) ? <td  style={cellStyle} className="ps-4 cursor-pointer" onClick={() => handlePaymentModal(clientValue, index)}>View</td> : ''} */}
                          </tr>

                          </>
                    )
                  })}
              </tbody>

            </table>
          </div>
        </> :


        <>
          <div className="p-2">
            <CommonTable
              show={showPaymentTable}
              hide={setShowPaymentTable}
              paymentTableData={paymentTableData}
              openModal={openModal}
              selectedUserData={selectedUserData}
              sessionsData={sessionsData}
              setSessionsData={setSessionsData}
              setPaymentTableData={setPaymentTableData}
              setOpenModal={setOpenModal}
              setLoader={false}
              sepratepayment={sepratepayment}
              setSepratepayment={setSepratepayment}
              payremaningModal={payremaningModal}
              setPayremaningModal={setPayremaningModal}
              setLastIndex={setLastIndex}
              refrencepage="billingCenter"
              AssigneeList={AssigneeList}
              getFormattedDateForCE={getFormattedDateForCE}
            />
          </div>
        </>
      }




    </>



    // </div>
  );
};


export default BillingCenterTableNew